export default __webpack_public_path__ + "media/images/casatb/tenant/how-to-rent-four-315760f597ec942a100622021d57842f.png";